import MaterialSymbol from './MaterialSymbol'

export default MaterialSymbol
